import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsAttributesStyles {
    wrapper?: InjectableCss;
    attributeTypeLabelText?: TypographyPresentationProps;
    attributeTypeValuesText?: TypographyPresentationProps;
    attributevalue?: TypographyPresentationProps;
    lableBox: InjectableCss;
    main: InjectableCss;
    valueBox: InjectableCss;
}

export const attributesStyles: ProductDetailsAttributesStyles = {
    wrapper: {
        css: css`
            margin-top: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 24px;
                    `,
                    css`
                        margin-top: 24px;
                    `,
                    css`
                        margin-top: 24px;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    attributeTypeLabelText: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            color: ${getColor("text.main")} !important;
        `,
    },
    attributeTypeValuesText: {
        css: css``,
    },
    attributevalue: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            color: ${getColor("text.main")} !important;
        `,
    },
    lableBox: {
        css: css`
            flex: 1 25%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex: 1 42%;
                    `,
                    css`
                        flex: 1 42%;
                    `,
                    css`
                        flex: 1 42%;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    main: {
        css: css`
            display: flex;
            justify-content: space-between;
            gap: 30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 15px;
                    `,
                    css`
                        gap: 15px;
                    `,
                    css`
                        gap: 15px;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    valueBox: {
        css: css`
            width: 100%;
        `,
    },
};

const styles = attributesStyles;

const ProductDetailsAttributes: React.FC<Props> = ({ product: { brand, attributeTypes } }) => {
    if (!brand && (!attributeTypes || attributeTypes.length === 0)) {
        return null;
    }

    /* const limitedAttributeTypes = (attributeTypes?.filter(attributeType => attributeType.includeOnProduct) ?? []).slice(
        0,
        5,
    ); */
    const limitedAttributeTypes = attributeTypes?.filter(attributeType => attributeType.includeOnProduct) ?? [];

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="productDetails_attributes">
            {/* {brand && (
                <Typography data-test-selector="brand_item" as="p" {...styles.attributeTypeValuesText}>
                    <Typography data-test-selector="brand_item_label" {...styles.attributeTypeLabelText}>
                        {translate("Brand")}
                    </Typography>
                    <span data-test-selector="brand_item_value">{brand.name}</span>
                </Typography>
            )} */}
            {limitedAttributeTypes.map(attributeType => (
                <Typography
                    key={attributeType.id.toString()}
                    data-test-selector="attributes_item"
                    data-attributetypeid={attributeType.id}
                    {...styles.attributeTypeValuesText}
                    as="p"
                >
                    <StyledWrapper {...styles.main}>
                        <StyledWrapper {...styles.lableBox}>
                            <Typography data-test-selector="attributes_item_label" {...styles.attributeTypeLabelText}>
                                {attributeType.label || attributeType.name}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.valueBox}>
                            <Typography data-test-selector="attributes_item_value" {...styles.attributevalue}>
                                {(attributeType.attributeValues ?? [])
                                    .map(attributeValue => attributeValue.valueDisplay)
                                    .join(", ")}
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </Typography>
            ))}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsAttributes),
    definition: {
        displayName: "Attributes",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
